import { jsxs, jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
const SvgWork = (props, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 201 194",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref,
    ...props,
    children: [
      /* @__PURE__ */ jsxs("defs", { children: [
        /* @__PURE__ */ jsxs("linearGradient", { x1: "0%", y1: "50%", x2: "100%", y2: "50%", id: "Work_svg__c", children: [
          /* @__PURE__ */ jsx("stop", { stopColor: "#23286B", offset: "0%" }),
          /* @__PURE__ */ jsx("stop", { stopColor: "#151A4F", offset: "100%" })
        ] }),
        /* @__PURE__ */ jsxs("linearGradient", { x1: ".747%", y1: "54.431%", x2: "133.345%", y2: "38.805%", id: "Work_svg__d", children: [
          /* @__PURE__ */ jsx("stop", { stopColor: "#A1C3FC", offset: "0%" }),
          /* @__PURE__ */ jsx("stop", { stopColor: "#78A9EF", offset: "100%" })
        ] }),
        /* @__PURE__ */ jsxs("linearGradient", { x1: "44.235%", y1: "27.331%", x2: "52.822%", y2: "61.879%", id: "Work_svg__e", children: [
          /* @__PURE__ */ jsx("stop", { stopColor: "#A1C3FC", offset: "0%" }),
          /* @__PURE__ */ jsx("stop", { stopColor: "#78A9EF", offset: "100%" })
        ] }),
        /* @__PURE__ */ jsxs("linearGradient", { x1: "0%", y1: "50%", x2: "100%", y2: "50%", id: "Work_svg__h", children: [
          /* @__PURE__ */ jsx("stop", { stopColor: "#EEE", offset: "0%" }),
          /* @__PURE__ */ jsx("stop", { stopColor: "#CED9E4", offset: "69.55%" }),
          /* @__PURE__ */ jsx("stop", { stopColor: "#C5D4E1", offset: "100%" })
        ] }),
        /* @__PURE__ */ jsx("path", { id: "Work_svg__a", d: "M0 0h138.071v190H0z" }),
        /* @__PURE__ */ jsx("path", { id: "Work_svg__f", d: "M0 0h139v104H0z" })
      ] }),
      /* @__PURE__ */ jsxs("g", { fill: "none", fillRule: "evenodd", children: [
        /* @__PURE__ */ jsxs("g", { transform: "matrix(-1 0 0 1 138.071 0)", children: [
          /* @__PURE__ */ jsx("mask", { id: "Work_svg__b", fill: "#fff", children: /* @__PURE__ */ jsx("use", { xlinkHref: "#Work_svg__a" }) }),
          /* @__PURE__ */ jsxs("g", { mask: "url(#Work_svg__b)", children: [
            /* @__PURE__ */ jsx("path", { fill: "#EEE", fillRule: "nonzero", d: "M1.293 87.25h82.173v4.915H1.293z" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                d: "M79.64 89.363c.237.285.24.69.25 1.06.053 1.984.99 7.148 1.688 5.64.525-2.074.56-4.27.1-6.36 1.022.77.87 2.304.781 3.58-.088 1.275 1.024 3.702 1.618 3.012.496-2.261.575-4.527.322-6.828a26.766 26.766 0 0 0 1.971 4.748c.111.208.248.433.475.495.6.16.751-.808.574-1.402-.739-2.475-1.872-5.34-4.39-5.928-1.252-.292-3.091-.337-3.146-1.62A160.172 160.172 0 0 0 84.81 71.9a5.7 5.7 0 0 1-4.027-2.6c-2.009 3.494-4.033 7.022-5.231 10.868-.365 1.173-.661 2.39-1.325 3.425-1.276 1.987-3.65 2.931-5.893 3.675-.866.287-1.926 1.237-1.264 1.863a26.136 26.136 0 0 1 8.735-1.373l3.159 1.204c.247.095.506.197.676.4ZM26.163 84.941c-.833-1.352 7.784-1.313 11.677-1.97 2.366-.399 4.824-.835 6.77-2.238 1.52-1.097 2.592-2.69 3.687-4.212a78.1 78.1 0 0 1 2.796-3.654c.422-.519.965-1.083 1.631-1.016.672.068 1.117.796 1.113 1.47-.004.674-.335 1.298-.658 1.89-1.06 1.95-2.122 3.899-3.184 5.849-.53.973-1.077 2.062-.818 3.14.483 2.01 4.343 3.028 4.314 4.286.03 1.04-4.384-.378-6.084-1.712-.282-.22-.554-.463-.882-.603-.738-.316-1.581-.061-2.351.166a30.829 30.829 0 0 1-16.395.26c-.034-.713.712-1.246 1.422-1.318.711-.072 1.412.167 2.12.26.94.122 2.149.102 3.086-.034 2.486-.361 3.65-.533 6.137-.894-5.132.492-13.616.957-14.381.33Z",
                fill: "#FFBEB6",
                fillRule: "nonzero"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                d: "M129.183 154.734a26.61 26.61 0 0 0 8.335 4.669 361.16 361.16 0 0 1-4.18 28.213c-3.532-1.467-6.14-4.663-7.584-8.2-1.445-3.538-1.843-7.411-1.948-11.23-.021-.759-.029-1.537.226-2.253.283-.797.864-1.444 1.335-2.147 1.685-2.517 1.96-5.758 3.56-8.33 1.272-2.044-1.78.565.256-.722Z",
                fill: "#D62929",
                fillRule: "nonzero"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                d: "M128.365 175.887c-.301 4.203-.052 12.539-.052 12.539s-27.105.255-32.474.255c.847-3.427 2.868-5.104 6.094-6.543.993-.443 2.041-.745 3.085-1.046l10.749-3.093c2.198-.632 4.416-1.269 6.698-1.434 2.045-.147 4.17.076 6.086-.65-2.186 3.467.107-4.115-.186-.028Z",
                fill: "#E94A47",
                fillRule: "nonzero"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                d: "M123.891 140.403c-1.103-1.36-2.645-2.53-4.017-3.566-2.178-1.647-1.658-2.927-3.068-5.363-1.019-1.76-3.288-3.56-4.405-5.249-.3-.454-.531-1.009-.44-1.555.073-.444.346-.813.608-1.163 7.17-9.609 11.97-21.043 15.832-32.684 1.306-3.936 2.53-8.103 1.913-12.25-1.1-7.378-7.485-12.3-13.318-16.352-1.169 4.536-4.725 7.76-7.434 11.434-2.709 3.673-4.624 9.05-2.162 12.975-3.43 11.702-6.7 23.46-9.809 35.268-.562 2.135-1.124 4.355-.796 6.556.312 2.102 1.404 3.966 2.472 5.763l8.24 13.873c4.382 7.375 8.791 14.808 11.789 22.941 2.405-4.446 5.492-8.455 9.1-11.815-2.287-4.766-3.571-10.083-3.726-15.43-.034-1.184-.053-2.487-.779-3.383Z",
                fill: "#151A4F",
                fillRule: "nonzero"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                d: "M131.367 154.553c.438-2.002 1.514-7.93 1.79-9.96.749-5.535-1.713-10.058-2.557-15.579-.516-3.376-.605-5.186-.576-8.6.041-4.942.79-6.379.831-11.32.036-4.251-.295-13.96.512-18.133.998-5.168 2.829-8.217 2.986-13.478.235-7.89-4.56-15.706-11.704-19.078-4.912 2.582-10.026 10.711-15.318 12.38 5.035 15.443 2.515 26.26 4.547 42.373.368 2.92.89 5.84 1.91 8.602.686 1.856 1.591 3.625 2.258 5.487 1.331 3.717 1.684 7.706 1.882 11.65a163.711 163.711 0 0 1-2.293 36.671 35.404 35.404 0 0 1 11.562 1.717c8.772-11.75 2.4-14.656 4.17-22.732Z",
                fill: "url(#Work_svg__c)",
                fillRule: "nonzero",
                transform: "translate(1.293 2.205)"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                d: "M88.156 24.252c-4.28.668-8.559 1.335-12.838 2.004-.888.138-1.789.28-2.608.627-2.383 1.011-6.415 6.95-7.299 9.246-2.777 7.212-3.98 9.978-6.137 16.345-3.502 10.34-6.241 19.055-13.744 27.412 6.848.452 6.324 3.378 13.063 4.597-1.705-8.173 9.895-23.566 15.341-36.436 1.451-3.428 2.383-10.27 5.52-12.524.98-.704 5.475-1.386 6.416-2.134 2.735-2.178 3.707-6.062 2.286-9.137Z",
                fill: "#81AEF2",
                fillRule: "nonzero"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                d: "M92.752 22.586c3.027 1.832 2.894 4.05 5.45 6.495 3.844 3.675 6.947 7.114 11.05 10.497 3.018 2.488 5.508 5.55 7.85 8.681 3.566 4.769 9.17 4.679 12.133 9.842-5.803 4.838-15.01 13.455-22.322 15.37.311-2.56-1.208-5.052-3.21-6.68-2.003-1.627-4.453-2.58-6.798-3.66-7.537-3.468-15.53-8.087-18.871-15.674-5.48-12.436-8.928-15.322-5.922-23.048.53-1.361 4.302-3.541 5.675-4.044 1.008-.369 1.186-1.696 2.238-1.483 2.672.542 10.395 2.292 12.727 3.704Z",
                fill: "url(#Work_svg__d)",
                fillRule: "nonzero",
                transform: "translate(1.293 2.205)"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                d: "M90.105 56.677c-.438-.138-.77.39-.924.822l-9.75 27.27",
                stroke: "#000",
                strokeWidth: 2.469
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                d: "M70.406 21.148c.805-.515 1.919-.223 2.647.395.728.619 1.14 1.54 1.625 2.362 1.331 2.256.533 1.375 2.6 2.985 2.214-.829 5.662-3.032 7.36-5.527-3.219-3.087-4.032-4.676-5.722-8.8a19.449 19.449 0 0 1-8.51 8.585Z",
                fill: "#F2A19C",
                fillRule: "nonzero"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                d: "m72.889 6.206-4.958 8.55c-.845 1.458-1.696 3.284-.832 4.73.886 1.481 2.968 1.559 4.692 1.458 1.273-.073 2.965-.6 2.841-1.867",
                stroke: "#000",
                strokeWidth: 2.469
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                d: "M71.729 15.13c.382-.968.336-2.04.392-3.078.056-1.038.256-2.147.994-2.88.737-.734 2.161-.83 2.72.047a9.077 9.077 0 0 1-1.046 5.173c-.324.598-.755 1.19-1.391 1.432-.637.24-1.502-.036-1.67-.695Z",
                stroke: "#000",
                strokeWidth: 2.469
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                d: "m76.748 19.365 3.9-4.08c.874-.916 1.765-1.856 2.281-3.011.988-2.214.334-5.005-1.432-6.667-1.767-1.662-4.488-2.166-6.79-1.4-3.34 1.113-5.95 5.172-8.399 7.698-.761.968 1.143 1.639.706 2.872-.525 1.482-.923 3.092-.53 4.613.394 1.52 1.346 2.745 3.378 2.697.621-.015 1.736-.11 2.329-.297 1.25-.395 2.102-.591 3.228-1.263.507-.303.922-.735 1.33-1.162Z",
                fill: "#FFBEB6",
                fillRule: "nonzero"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                d: "M72.172 13.615c-.357 0-.701-.07-1.025-.21-1.48-.639-2.082-2.55-1.343-4.26.558-1.288 1.764-2.154 3.002-2.154.356 0 .7.07 1.024.21 1.48.639 2.082 2.55 1.343 4.26-.558 1.289-1.764 2.154-3.001 2.154Zm.634-6.113c-1.037 0-2.054.741-2.532 1.845-.628 1.452-.145 3.062 1.076 3.589.26.112.535.169.822.169 1.036 0 2.054-.742 2.531-1.846.628-1.453.145-3.062-1.076-3.59a2.069 2.069 0 0 0-.821-.167ZM75.95 32.859s-.385-3.336-.644-4.888a9.678 9.678 0 0 0 3.682.25c-.985 1.867-1.152 2.84-1.543 4.914-.556-.255-1.494-.276-1.494-.276Z",
                fill: "#23286B",
                fillRule: "nonzero"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                d: "M77.408 32.9a1.328 1.328 0 0 1-1.452-.564c-.816 3.41.234 6.952.532 10.446.382 4.478-.482 8.956-.758 13.441-.276 4.486.122 9.26 2.693 12.949-.319-7.652.026-15.33 1.028-22.923.161-1.22.34-2.454.219-3.68-.327-3.326-2.82-6.373-2.262-9.67Z",
                fill: "#151A4F",
                fillRule: "nonzero"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                d: "M88.069 22.58c-1.439-.443-3.501-1.613-4.759-2.653-1.363 2.921-3.017 5.703-6.031 6.853.779 2.842 1.415 5.828 1.25 8.77 3.008-3.408 4.947-4.712 7.548-8.439 1.272-1.823 2.556-4.358 1.992-4.532Z",
                fill: "#EEE",
                fillRule: "nonzero"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                d: "M81.672 17a.256.256 0 0 1-.096-.492c4.744-1.92 8.993-8.486 9.092-14.053.003-.14.125-.236.26-.25a.256.256 0 0 1 .252.26c-.102 5.746-4.501 12.53-9.412 14.515a.244.244 0 0 1-.096.02Z",
                fill: "#428DFC",
                fillRule: "nonzero"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                d: "M97.87 32.562c.214-4.017-3.044-10.764-7.16-10.3-4.718.53-4.378 2.86-5.056 7.479-.829 5.653-2.576 17.4-4.149 23.933-2.594 10.772-4.794 16.43-7.863 26.305 3.498 3.331 6.39 3.043 10.36 5.833 1.476-6.134 2.276-5.918 4.322-17.495.746-4.223 2.984-15.959 4.09-20.09 2.088-7.788 5.028-7.623 5.456-15.665Z",
                fill: "url(#Work_svg__e)",
                fillRule: "nonzero",
                transform: "translate(1.293 2.205)"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                d: "M66.746 11.572a.907.907 0 0 1-.362-.073c-.809-.35-.91-1.79-.235-3.352.655-1.512 1.821-2.464 2.605-2.126.81.349.91 1.79.235 3.351-.56 1.295-1.482 2.2-2.243 2.2Zm1.646-5.114c-.462 0-1.242.663-1.773 1.892-.579 1.338-.481 2.486-.032 2.68.438.188 1.334-.478 1.932-1.86.58-1.338.481-2.486.032-2.68a.39.39 0 0 0-.159-.032Z",
                fill: "#23286B",
                fillRule: "nonzero"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                d: "M77.334 26.835s-3.544 4.815-3.818 7.24c-.082-2.801-.72-4.808-.277-7.406.798-1.383.696-1.38 1.494-2.764.578 1.752 2.601 2.93 2.601 2.93Z",
                fill: "#EEE",
                fillRule: "nonzero"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                d: "M89.023 2.241H71.072c-2.259 2.165-.988 3.466-.82 5.171.98-1.441 5.035-.915 6.365.31 1.33 1.224 1.359 3.168.551 4.684.924-.615 2.388.146 2.642 1.116.254.97-.278 1.949-.796 2.84l-.633 1.09c1.357.282 2.814-.122 3.942-.819 1.128-.697 1.981-1.659 2.788-2.623 2.593-3.098 4.984-6.708 4.397-10.47-.024-.159-.335-1.224-.485-1.299ZM126.311 174.383l-.446-.248a18.052 18.052 0 0 0 2.28-8.392c.033-1.547-.137-3.122-.301-4.646-.182-1.684-.37-3.427-.289-5.155.108-2.312.693-4.587 1.26-6.786.528-2.049 1.074-4.166 1.223-6.292.271-3.854-.747-7.707-1.733-11.434-.232-.882-.464-1.761-.68-2.64a75.365 75.365 0 0 1-2.073-22.017c.192-3.62.65-7.32 1.092-10.897 1.057-8.551 2.15-17.393-.328-25.664l.49-.147c2.51 8.374 1.41 17.27.346 25.874-.442 3.57-.898 7.26-1.09 10.862a74.881 74.881 0 0 0 2.058 21.867c.216.877.448 1.754.68 2.631.995 3.768 2.025 7.663 1.748 11.601-.153 2.172-.705 4.313-1.238 6.384-.56 2.174-1.14 4.423-1.245 6.683-.078 1.688.107 3.41.287 5.076.166 1.54.337 3.132.305 4.712a18.566 18.566 0 0 1-2.346 8.628Z",
                fill: "#428DFC",
                fillRule: "nonzero"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                d: "M109.634 52.831c-.037-.08-.155-.123-.236-.086-.08.036-.124.154-.087.235.037.08.155.123.236.086.081-.036.143-.114.087-.235ZM100.888 38.1c.044-.117.007-.197-.111-.242-.078-.062-.199-.006-.261.07-.043.118-.007.199.111.243.118.044.199.007.261-.07Zm-1.76 4.029c.044-.118.007-.198-.111-.243-.118-.044-.199-.006-.243.111-.062.078-.007.198.112.242.1.003.22-.052.242-.11Zm8.178 2.79c-.078-.062-.177-.065-.239.012-.062.078-.065.176.012.239.078.062.177.065.24-.012.08-.037.065-.176-.013-.239Zm-3.14 3.05c-.077-.062-.176-.065-.238.012-.062.078-.065.176.012.239.078.062.176.065.239-.012.062-.077.065-.177-.012-.239ZM92 38.22c.004-.099-.075-.161-.173-.164-.1-.003-.162.074-.164.173-.004.1.074.161.133.183.139-.016.2-.093.204-.192Zm18.244 9.89c-.037-.08-.137-.083-.217-.046-.08.037-.083.136-.047.216.037.08.137.084.217.047.062-.077.084-.136.047-.216Zm-3.08 2.438c-.036-.081-.136-.084-.216-.047-.08.036-.084.136-.047.216.037.08.137.084.217.047.12-.055.124-.154.047-.216ZM95.852 40.213c.004-.099-.074-.16-.133-.183-.1-.003-.18.034-.183.133-.004.1.034.18.133.183.059.021.14-.016.183-.133ZM108.65 57.48c-.037-.08-.115-.142-.195-.105-.08.037-.143.114-.106.194.037.081.115.143.195.106.08-.037.142-.114.106-.195Zm-5.492-12.76c.063-.077.007-.197-.052-.22-.078-.062-.158-.024-.22.053-.063.077-.025.158.052.22.078.062.199.006.22-.052Zm-1.898 3.41c.062-.078.025-.158-.053-.22-.077-.063-.158-.026-.22.052-.062.077-.025.157.052.22.078.062.159.025.22-.052Zm7.81 7.4c-.02-.04-.118-.043-.158-.024-.04.018-.044.117-.025.158.018.04.117.044.158.025.08-.038.062-.077.025-.158Zm-9.624-5.398c.022-.059-.037-.08-.096-.102-.06-.022-.121.056-.102.096-.022.06.055.121.096.102.058.02.08-.037.102-.096Zm10.835 10.993c-.019-.04-.096-.102-.136-.084-.04.019-.103.096-.084.137.019.04.096.102.136.083.08-.037.103-.096.084-.136Zm1.44-16.913c.063-.077.007-.197-.07-.26-.079-.062-.2-.007-.262.07-.062.078-.006.198.071.261.078.062.2.007.261-.07Zm-2.175 3.975c.062-.078.006-.198-.071-.26-.078-.063-.199-.007-.261.07-.063.077-.007.198.07.26.12.044.2.007.262-.07Zm-2.135 3.955c.062-.077.006-.197-.071-.26-.078-.062-.199-.007-.261.07-.063.078-.007.198.07.26.079.064.2.008.262-.07Zm3.23 5.206c-.078-.062-.195-.106-.257-.028-.062.077-.106.194-.028.256s.195.106.257.029.106-.195.028-.257Zm-8.095-13.956c.003-.1-.093-.202-.193-.205-.099-.004-.202.092-.204.191-.004.1.052.22.152.224.139-.016.2-.093.245-.21Zm-.464 4.507c.003-.1-.052-.22-.192-.205-.1-.004-.162.074-.224.151-.003.1.052.22.152.223.159.025.22-.052.264-.17Zm8.931 12.695c-.077-.063-.194-.106-.257-.029-.062.078-.106.195-.028.256.037.081.155.124.257.03.081-.037.125-.155.028-.257Zm-5.393-17.636c.004-.1-.052-.22-.152-.223-.1-.003-.22.052-.223.151-.004.1.034.18.152.223.099.004.22-.051.223-.151Zm-.68 4.461c.004-.099-.052-.22-.152-.223-.099-.004-.18.034-.223.151-.004.1.052.22.152.223.139-.015.22-.052.223-.15Zm-.64 4.441c.003-.099-.053-.22-.153-.223-.099-.003-.22.052-.223.151-.004.1.052.22.152.224.117.044.22-.053.223-.152Zm7.001.452c.063-.078.007-.198-.07-.26-.078-.063-.2-.007-.262.07-.062.078-.006.198.072.26.117.044.197.007.26-.07Zm-2.312 3.89c.063-.077.007-.197-.07-.26-.078-.062-.2-.007-.262.07-.062.078-.006.198.072.261.117.044.198.007.26-.07Zm-6.068-5.955c.003-.099-.056-.12-.155-.123-.1-.004-.122.055-.125.155-.004.099.056.12.155.123.081-.037.121-.056.125-.155Zm6.689 2.742c.021-.059-.016-.14-.074-.16-.06-.023-.14.014-.162.073-.021.06.016.14.075.161.058.022.138-.015.16-.074Zm-1.117 3.197c.021-.06-.016-.14-.093-.202-.06-.022-.14.016-.16.074-.022.06.014.14.073.16.095.104.176.067.18-.032Z",
                fill: "#FFF",
                fillRule: "nonzero",
                opacity: 0.86
              }
            )
          ] })
        ] }),
        /* @__PURE__ */ jsx("path", { fill: "#89B3F4", d: "M162.102 89.412h-31.897v-4.66h31.897z" }),
        /* @__PURE__ */ jsx("path", { fill: "#A1C3FC", d: "m201 56.503-9.139 32.909h-39.638l9.138-32.909z" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M177.796 70.118a3.405 3.405 0 1 0 .001 6.81 3.405 3.405 0 0 0-.001-6.81",
            fill: "#89B3F4"
          }
        ),
        /* @__PURE__ */ jsxs("g", { transform: "matrix(-1 0 0 1 196 90)", children: [
          /* @__PURE__ */ jsx("mask", { id: "Work_svg__g", fill: "#fff", children: /* @__PURE__ */ jsx("use", { xlinkHref: "#Work_svg__f" }) }),
          /* @__PURE__ */ jsx("g", { mask: "url(#Work_svg__g)", fill: "url(#Work_svg__h)", fillRule: "nonzero", children: /* @__PURE__ */ jsx("path", { d: "M.025 0 0 104h2.61L2.635 2.62h133.913V104H139V0z" }) })
        ] })
      ] })
    ]
  }
);
const ForwardRef = forwardRef(SvgWork);
export {
  ForwardRef as default
};
